export default __webpack_public_path__ + "locales/lo-LA/Ldap.json?hash=bf7c23d368a8d9285157b65d1dda1003";